import styled from "styled-components";

export const Header = styled.h3`
    padding-top: 1.5rem;
`;

export const Container = styled.div`
    background-color: #f3f6f8;
    padding: 2rem;
`;
